module.exports = __webpack_public_path__ + "img/teacher.f2e80977.svg";